import React from 'react';
import { Reveal, StaggerReveal, Eyebrow, TiltCard } from '../ui';

const testimonials = [
  { initials: 'TM', color: 'from-rose to-rose-dark', name: 'Takondwa M.', loc: 'Lilongwe', quote: '"I had almost given up on dating apps. Within two weeks on Max & Sherry I connected with someone who loves hiking and road trips just like I do. We\'ve been inseparable since."' },
  { initials: 'CN', color: 'from-blue-500 to-blue-400', name: 'Chisomo N.', loc: 'Blantyre', quote: '"The interest matching is genuinely different. I\'m into football and music and every person I connected with actually shared those passions. The Connect plan was worth every kwacha."' },
  { initials: 'EP', color: 'from-emerald-500 to-emerald-400', name: 'Ellen P.', loc: 'Mzuzu', quote: '"The Exclusive plan\'s personal curation was something else entirely. The Max & Sherry team hand-picked profiles for me. It felt like having my own personal matchmaker."' },
];

export default function Testimonials() {
  return (
    <section className="bg-blush py-16 lg:py-[100px] px-[5%]" id="testimonials">
      <Reveal><Eyebrow>Success stories</Eyebrow></Reveal>
      <Reveal delay={100}>
        <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-8 lg:mb-16">Real connections, real people.</h2>
      </Reveal>
      <StaggerReveal className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {testimonials.map((t) => (
          <TiltCard key={t.name} className="bg-white rounded-[20px] p-7 lg:p-9">
            <div className="text-amber-400 text-sm tracking-[2px] mb-[18px]">★★★★★</div>
            <p className="text-[15px] text-muted leading-relaxed italic mb-6 font-light">{t.quote}</p>
            <div className="flex items-center gap-3">
              <div className={`w-[42px] h-[42px] rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center text-white font-bold text-[15px] flex-shrink-0`}>{t.initials}</div>
              <div>
                <div className="text-sm font-semibold">{t.name}</div>
                <div className="text-xs text-muted">📍 {t.loc}</div>
              </div>
            </div>
          </TiltCard>
        ))}
      </StaggerReveal>
    </section>
  );
}
